import { render, staticRenderFns } from "./UserTradeCom.vue?vue&type=template&id=5e0e4046&scoped=true&"
import script from "./UserTradeCom.vue?vue&type=script&lang=js&"
export * from "./UserTradeCom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e0e4046",
  null
  
)

export default component.exports